// Generated by ReScript, PLEASE EDIT WITH CARE


var title = {
  id: "8afd972b-e71c-418f-91f9-9b7fa27ad850",
  defaultMessage: "Set the minimum margin amount"
};

var newMinimum = {
  id: "b1218004-5f1a-4978-9728-a2ce3cfca153",
  defaultMessage: "New minimum amount"
};

var minimum = {
  id: "6e38bb69-47de-4bb3-ab3d-bf80038f1e40",
  defaultMessage: "Minimum amount"
};

var budgetYear = {
  id: "79c3f1e5-2e88-4dfb-9ffd-fa4744dd9410",
  defaultMessage: "Budget year"
};

var resultInfo = {
  id: "28940284-bff4-430c-b42a-0df233c96a01",
  defaultMessage: "rows"
};

export {
  title ,
  newMinimum ,
  minimum ,
  budgetYear ,
  resultInfo ,
}
/* No side effect */
